import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["highlights", "empty"];
import React from "react";
export var Highlights = function Highlights(_ref) {
  var highlights = _ref.highlights,
      empty = _ref.empty,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  if (!highlights.length && !empty) return null;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: "highlights"
  }, otherProps), /*#__PURE__*/React.createElement("h2", null, "Highlights"), empty && /*#__PURE__*/React.createElement("p", null, "Click here to add highlights"), /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dd", null, /*#__PURE__*/React.createElement("ul", {
    className: "detailed"
  }, highlights.map(function (highlight) {
    return /*#__PURE__*/React.createElement("li", {
      key: highlight
    }, highlight);
  })))));
};